import { createSlice } from "@reduxjs/toolkit";
import { FACEBOOK_CONFIG } from "../../../constants/reducer_names";



const initialState: any = {
    configData:[] as any
} as any;

const facebookConfigSlice = createSlice({
    name: FACEBOOK_CONFIG,
    initialState,
    reducers: {
        setConfigData: (state, { payload }) => {
            state.configData=payload
        }
    }
});


export const FacebookConfigActions = facebookConfigSlice.actions;
export default facebookConfigSlice.reducer;



